var touch_price_x = -1;
var touch_price_y = -1;
var touch_price_t = -1;
var touch_price_tm = null;

function touch_price_end() {
	touch_price_x = -1;
	touch_price_y = -1;
	touch_price_t = -1;
	$('#plans3 .item_act, #plans3 .item_act2').css({left: ''}).parent().addClass('anim');
}

$(document).ready(function () {

	$('#step1').on('mousedown touchstart', function (e) {
		if ($(window).width() > 800) return;
		if (touch_price_tm) window.clearTimeout(touch_price_tm);
		touch_price_tm = window.setTimeout(touch_price_end, 1000);
		var touch = e;
		if (e.type == 'touchstart') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e; //event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : e.originalEvent.touches[0];
		}
		touch_price_x = touch.pageX;
		touch_price_y = touch.pageY;
		touch_price_t = 0;
	}).on('mousemove touchmove', function (e) {
		if (touch_price_t == 1 || touch_price_x == -1) return; // top-botom
		if (touch_price_t == 2) e.preventDefault(); // left-right
		if (touch_price_t == -1) return; // for mouse
		var touch = e;
		if (e.type == 'touchmove') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e; //event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : e.originalEvent.touches[0];
		}
		this_x = touch.pageX;
		this_y = touch.pageY;
		if (touch_price_t == 0) {
			if (Math.abs(this_x - touch_price_x) > Math.abs(this_y - touch_price_y) + 2) {
				touch_price_t = 2;
				e.preventDefault();
			} else if (Math.abs(this_x - touch_price_x) + 2 < Math.abs(this_y - touch_price_y)) {
				touch_price_t = 1;
				return;
			} else {
				return;
			}
		}
		if (touch_price_tm) window.clearTimeout(touch_price_tm);
		touch_price_tm = window.setTimeout(touch_price_end, 1000);
		if (this_x - touch_price_x > 50) {
			$('#plans3 .item_act, #plans3 .item_act2').css({left: ''});
			//let pricemove = !($('body').hasClass('bd_landing') ? $('#plans3 .item').eq(1).hasClass('item_act') : $('#plans3 .item:first').hasClass('item_act'));
			if (!$('#plans3 .item:first').hasClass('item_act')) {
				$('#plans3 .item_act').prev().addClass('item_act').removeClass('item_l').next().removeClass('item_act').addClass('item_act2').next().removeClass('item_act2').addClass('item_r');
				$('#step1 .pages .act').prev().addClass('act').next().removeClass('act').addClass('act2').next().removeClass('act2');
			}
			touch_price_end();
			return;
		}
		if (this_x - touch_price_x < -50) {
			$('#plans3 .item_act, #plans3 .item_act2').css({left: ''});
			if (!$('#plans3 .item:last').hasClass('item_act2')) {
				$('#plans3 .item_act').removeClass('item_act').addClass('item_l').next().removeClass('item_act2').addClass('item_act').next().addClass('item_act2').removeClass('item_r');
				$('#step1 .pages .act').removeClass('act').next().removeClass('act2').addClass('act').next().addClass('act2');
			}
			touch_price_end();
			return;
		}
		$('#plans3 .item_act').css({left: 76 + this_x - touch_price_x});
		$('#plans3 .item_act2').css({left: 190 + this_x - touch_price_x});
	}).on('mouseup', touch_price_end);

	$('.whint').hover(function () {
		$('#whint').show().html($(this).find('font').html()).css({
			'top': $(this).offset().top + $(this).outerHeight() + 5,
			'left': $(this).offset().left + Math.round(0.5 * $(this).outerWidth())
		});
	}, function () {
		$('#whint').hide();
	});

	$('#step1 .item').on('click', function (e) {
		if (!$(e.target).is('a')) {
			$($(this).find('a').get(0)).trigger('click');
		}
	});

	if ($('#step3').length) {
		if ($(window).scrollTop() >= $('#step3').offset().top + 50) $('#step3 .more').css({opacity: 0});
		else if ($(window).scrollTop() >= $('#step3').offset().top - 70) $('#step3 .more').css({
			opacity: 1,
			top: $(window).scrollTop() - $('#step3').offset().top
		});
		else $('#step3 .more').css({opacity: 1, top: -70});

		if ($(window).scrollTop() >= $('#step3').offset().top + 50) $('#step3 h3').css({opacity: 0});
		else $('#step3 h3').css({opacity: 1});

		if ($(window).scrollTop() + $(window).height() >= $('#step3').offset().top - 80) {
			$('#help').css({marginTop: 90 - Math.min(80, $(window).scrollTop() + $(window).height() - $('#step3').offset().top + 80)});
			$('#step2 .cards').css({top: 20 + Math.min(80, $(window).scrollTop() + $(window).height() - $('#step3').offset().top + 80)});
		} else {
			$('#help').css({marginTop: 90});
			$('#step2 .cards').css({top: 20});
		}
	}
});


$(window).on('resize scroll', function () {
	if ($('#step1').length && !$('body').hasClass('home')) {
		if ($(window).scrollTop() < $('#step1').height() - 250) $('#step1 .more').css({
			opacity: 1,
			bottom: Math.min(320, Math.max(50, $('#step1').height() - $(window).height() - $(window).scrollTop() + 50))
		});
		else $('#step1 .more').css({opacity: 0, bottom: 50});
	}
});